<template>
  <div class="battery-mgmt">
    <div class="main-title">
      <p>权限方案管理</p>
    </div>
    <div class="main-body">
      <el-form size="mini" :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button class="w100" type="primary" @click="handleAdd"
            >新增</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        :data="recordList"
        style="width: 100%;margin-bottom: 20px;"
        cell-class-name="text-center"
        row-key="number"
        v-loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column prop="number" label="编号"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="text" size="mini"
              >编辑</el-button
            >
            <el-button @click="handleDelete(scope.row)" type="text" size="mini"
              >删除</el-button
            >
            <el-button
              @click="handleSetting(scope.row, 1)"
              type="text"
              size="mini"
              >配置菜单</el-button
            >
            <el-button
              @click="handleSetting(scope.row, 2)"
              type="text"
              size="mini"
              >配置资源</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      :title="opearteType == '1' ? '新增权限方案' : '编辑认证信息权限方案'"
      :visible.sync="dialogTableVisible"
      width="500px"
      :show-close="false"
    >
      <el-form ref="form" :model="editRecord" label-width="80px">
        <el-form-item label="名称">
          <el-input
            v-model="editRecord.name"
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">确定</el-button>
          <el-button @click="closeDialog">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :visible.sync="relationDialogVisible"
      width="500px"
      :show-close="false"
      v-loading="loading"
      :element-loading-text="loadingText"
      element-loading-spinner="el-icon-loading"
    >
      <div
        style="margin-bottom: 20px; font-size: 15px; font-weight: bold; color: #3596F7"
      >
        权限方案：{{ relation.name }}
      </div>
      <el-form ref="form" :model="relation" label-width="120px">
        <div v-if="relation.relatedType == '1'">
          <el-form-item label="选择平台">
            <el-select
              v-model="relation.platformType"
              placeholder="请选择平台类型"
              @change="getAllMenu()"
            >
              <el-option label="web应用" value="3"></el-option>
              <el-option label="ios应用" value="1"></el-option>
              <el-option label="android应用" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择菜单">
            <el-tree
              :data="menuOptions"
              show-checkbox
              default-expand-all
              node-key="number"
              ref="menuTree"
              highlight-current
              :props="{
                value: 'number',
                label: 'name',
                children: 'subMenuList',
              }"
            ></el-tree>
          </el-form-item>
        </div>
        <div v-if="relation.relatedType == '2'">
          <el-form-item label="选择服务资源">
            <el-tree
              :data="resourceOptions"
              show-checkbox
              default-expand-all
              node-key="number"
              ref="resourceTree"
              highlight-current
              :props="{
                value: 'number',
                label: 'name',
                children: 'serviceResourceList',
              }"
            ></el-tree>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" @click="onSettingSubmit">确定</el-button>
          <el-button @click="closeDialog">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Utils from "../utils/utils";
export default {
  name: "authoritySchemeMgmt",
  data() {
    return {
      token: Utils.getLocalStorage("token"),
      recordList: [],
      dialogTableVisible: false,
      relationDialogVisible: false,
      opearteType: "",
      settingType: "",
      editRecord: {},
      menuOptions: [],
      resourceOptions: [],
      relation: {},
      loading: false,
      loadingText: "数据加载中...",
    };
  },
  mounted() {
    this.queryRecordList();
  },
  methods: {
    setCheckMenus(menuList) {
      let checkedMenuNos = [];
      let self = this;
      menuList.forEach((checkedMenu) => {
        let notFound = true;
        self.menuOptions.forEach((menu) => {
          if (checkedMenu.number == menu.number) {
            notFound = false;
          }
        });
        if (notFound) {
          checkedMenuNos.push(checkedMenu.number);
        }
      });
      this.$refs.menuTree.setCheckedKeys(checkedMenuNos);
    },

    setCheckResources(resources) {
      let checkedResourceNos = [];
      let self = this;
      resources.forEach((resource) => {
        checkedResourceNos.push(resource.number);
      });
      this.$refs.resourceTree.setCheckedKeys(checkedResourceNos);
    },

    handleCheckAllChange(checked, index) {
      let checkedResources = [];
      this.resourceOptions[index].serviceResourceList.forEach((element) => {
        checkedResources.push(element.number);
      });
      this.checkedResources[index] = checked ? checkedResources : [];
      this.isIndeterminate[index] = false;
    },
    handleCheckedCitiesChange(value, index) {
      let checkedCount = value.length;
      let totalLength = this.resourceOptions[index].serviceResourceList.length;
      let checkAll = JSON.parse(JSON.stringify(this.checkAll));
      let isIndeterminate = JSON.parse(JSON.stringify(this.isIndeterminate));
      checkAll[index] = checkedCount === totalLength;
      isIndeterminate[index] = checkedCount > 0 && checkedCount < totalLength;
      this.checkAll = checkAll;
      this.isIndeterminate = isIndeterminate;
    },
    queryRecordList() {
      let self = this;
      self.loading = true;
      self.loadingText = "数据加载中...";
      this.$http
        .get("/admin/authorityScheme/getAll", {
          headers: { token: this.token },
        })
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "查询失败!");
            return;
          }
          self.recordList = res.ldata;
        })
        .catch(function(response) {
          self.loading = false;
        });
    },

    handleAdd: function() {
      this.opearteType = "1";
      this.editRecord = {};
      this.dialogTableVisible = true;
    },

    onSubmit: function() {
      this.createOrUpdate();
    },

    createOrUpdate: function() {
      let self = this;
      if (self.editRecord.parentMenuNos) {
        self.editRecord.parentMenuNo =
          self.editRecord.parentMenuNos[
            self.editRecord.parentMenuNos.length - 1
          ];
      }
      self.loading = true;
      self.loadingText = "数据处理中...";
      this.$http
        .get(
          "/admin/authorityScheme/createOrUpdate?" +
            this.$qs.stringify(self.editRecord),
          {
            headers: { token: this.token },
          }
        )
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "操作失败!");
            return;
          }
          self.$message({
            type: "success",
            message: "操作成功",
            center: true,
          });
          self.closeDialog();
          self.queryRecordList();
        })
        .catch(function(response) {
          self.loading = false;
        });
    },

    onSettingSubmit() {
      let relatedNos = this.relation.relatedNos;
      let relatedNoSet = new Set();
      if (relatedNos) {
        relatedNos.forEach((element) => {
          element.forEach((num, index) => {
            if (index > 0) {
              relatedNoSet.add(num);
            }
          });
        });
      }
      this.relation.relatedNoSet = relatedNoSet;
      this.createOrUpdateRelation();
    },

    createOrUpdateRelation() {
      let self = this;
      let relatedNoSet = [];
      let relatedType = self.relation.relatedType;
      if (relatedType == "1") {
        relatedNoSet = this.$refs.menuTree
          .getCheckedKeys()
          .concat(this.$refs.menuTree.getHalfCheckedKeys());
      } else {
        relatedNoSet = this.$refs.resourceTree.getCheckedKeys(true);
      }

      let param = {
        authoritySchemeNo: self.relation.number,
        relatedType: self.relation.relatedType,
        relatedNoSet: relatedNoSet,
      };
      self.loading = true;
      self.loadingText = "数据处理中...";
      this.$http
        .post(
          "/admin/authorityScheme/relation/createOrUpdate",
          JSON.stringify(param),
          {
            headers: {
              token: this.token,
              "Content-Type": "application/json;charset=UTF-8",
            },
          }
        )
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "操作失败!");
            return;
          }
          self.$message({
            type: "success",
            message: "操作成功",
            center: true,
          });
          self.closeDialog();
          self.queryRecordList();
        })
        .catch(function(response) {
          self.loading = false;
        });
    },

    getAllResourceByNumber(number) {
      let self = this;
      self.loading = true;
      self.loadingText = "数据加载中...";
      let param = {
        authoritySchemeNo: number,
      };
      this.$http
        .get(
          "/admin/serviceResource/findByAuthoritySchemeNo?" +
            this.$qs.stringify(param),
          {
            headers: { token: this.token },
          }
        )
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "操作失败!");
            return;
          }
          self.setCheckResources(res.ldata);
        })
        .catch(function(response) {
          self.loading = false;
        });
    },

    getAllMenuByNumber(number) {
      let self = this;
      self.loading = true;
      self.loadingText = "数据加载中...";
      let param = {
        authoritySchemeNo: number,
      };
      this.$http
        .get(
          "/admin/application/menu/findByAuthoritySchemeNo?" +
            this.$qs.stringify(param),
          {
            headers: { token: this.token },
          }
        )
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "操作失败!");
            return;
          }
          self.setCheckMenus(res.ldata);
        })
        .catch(function(response) {
          self.loading = false;
        });
    },

    closeDialog: function() {
      this.dialogTableVisible = false;
      this.relationDialogVisible = false;
    },
    handleEdit: function(row) {
      this.opearteType = "2";
      this.dialogTableVisible = true;
      this.menuOptions = [];
      this.editRecord = JSON.parse(JSON.stringify(row));
    },

    handleSetting(row, type) {
      this.loading = true;
      this.relationDialogVisible = true;
      let relation = JSON.parse(JSON.stringify(row));
      relation.relatedType = type;
      relation.relatedNos = [];
      relation.platformType = "3";
      this.relation = relation;
      if (type == 1) {
        this.getAllMenu();
      } else {
        this.getAllResource();
      }
    },

    handleDelete(item) {
      this.$confirm("是否确认删除？").then(() => {
        this.delete(item.number);
      });
    },

    delete(number) {
      let self = this;
      let params = {
        number: number,
      };
      self.loading = true;
      self.loadingText = "数据处理中...";
      this.$http
        .get("/admin/authorityScheme/delete?" + this.$qs.stringify(params), {
          headers: { token: this.token },
        })
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "操作失败!");
            return;
          }
          self.$message({
            type: "success",
            message: "操作成功",
            center: true,
          });
          self.queryRecordList();
        })
        .catch(function(response) {
          self.loading = false;
        });
    },

    getRelated(type) {},

    getAllMenu() {
      let self = this;
      self.loading = true;
      self.loadingText = "数据加载中...";
      let params = {
        platformType: this.relation.platformType || "3",
        recursion: true,
      };
      this.$http
        .get(
          "/admin/application/menu/findByParentMenuNoAndPlatformType?" +
            this.$qs.stringify(params),
          {
            headers: { token: this.token },
          }
        )
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "查询失败!");
            return;
          }
          self.menuOptions = res.ldata;
          self.getAllMenuByNumber(self.relation.number);
        })
        .catch(function(response) {
          self.loading = false;
        });
    },

    getAllResource() {
      let self = this;
      self.loading = true;
      self.loadingText = "数据加载中...";
      this.$http
        .get("/admin/serviceResource/group/findAll?findChildren=true", {
          headers: { token: this.token },
        })
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "查询失败!");
            return;
          }
          self.resourceOptions = res.ldata;
          self.checkAll = [];
          self.isIndeterminate = [];
          self.checkedResources = [];
          self.resourceOptions.forEach((element) => {
            self.checkAll.push(false);
            self.isIndeterminate.push(true);
            self.checkedResources.push([]);
          });
          self.getAllResourceByNumber(self.relation.number);
        })
        .catch(function(response) {
          console.log(response);
          self.loading = false;
        });
    },

    handleQuery() {
      this.beginIndex = 0;
      this.queryRecordList();
    },
    showErrorMessage(message) {
      if (message == "0000") {
        this.$message({
          type: "warning",
          message: "请先登录",
          center: true,
        });
      } else if (message == "0001") {
        this.$message({
          type: "warning",
          message: "未认证",
          center: true,
        });
      } else if (message == "0002") {
        this.$message({
          type: "warning",
          message: "无权限",
          center: true,
        });
      } else {
        this.$message({
          type: "error",
          message: message,
          center: true,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-body {
  .list {
    line-height: 30px;
    margin: 20px 30px 10px;

    .name-label {
      float: left;
    }

    .value-label {
      display: inline-block;
      height: 30px;
    }

    .date-global {
      width: 185px;
    }

    .list-input {
      width: 180px;
    }

    .fixed-width-100 {
      width: 100px;
    }

    .fixed-width-200 {
      width: 200px;
    }

    .fixed-width-300 {
      width: 300px;
    }

    .fixed-width-400 {
      width: 400px;
    }
  }

  .table-custom {
    border-bottom: 1px solid #cdcdcd;
    .text-btn {
      width: 50px;
      height: 24px;
      line-height: 24px;
      color: #4949ff;
      display: inline-block;
      background-color: #67aff6;
      cursor: pointer;
    }

    .text-btn.disabled {
      border: #67aff6;
      background-color: #fff;
      cursor: default;
    }

    .fixed-width-75 {
      width: 75px;
    }

    .fixed-width-100 {
      width: 100px;
    }

    .fixed-width-300 {
      width: 300px;
    }

    .mt4 {
      margin-top: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/authoritySchemeMgmt.vue